(() => {
  const shell = document.querySelector('.ourstory-shell');
  if (!shell) return;
  const $ = (id) => shell.querySelector(`#${id}`);
  const apiBase = shell.dataset.apiBase;
  const variants = {
    card: Number(shell.dataset.cardVariant),
    mini: Number(shell.dataset.miniVariant)
  };
  const checkoutAvailable = {
    card: shell.dataset.cardAvailable === 'true',
    mini: shell.dataset.miniAvailable === 'true' && shell.dataset.miniCheckoutEnabled === 'true'
  };
  shell.querySelectorAll('[data-open-wizard][data-product]').forEach((button) => {
    const productType = button.dataset.product;
    if (productType && !checkoutAvailable[productType]) {
      button.textContent = `${button.textContent.replace(/\s*·\s*Coming soon$/, '')} · Coming soon`;
      button.setAttribute('aria-description', 'A free preview is available, but checkout is not yet open for this product.');
    }
  });
  const miniEditions=JSON.parse($('miniEditionMap').textContent);
  function selectedMiniEdition(){const size=form.querySelector('[name=mini_size]:checked')?.value||'A5',binding=form.querySelector('[name=mini_binding]:checked')?.value||'softcover',digital=form.querySelector('[name=mini_digital]')?.checked;return miniEditions[`${size}-${binding}${digital?'-digital':''}`];}
  const slugFor = { card: 'story-card', mini: 'mini-story' };
  const limits = { card: [1, 2], mini: [5, 20] };
  const reveals = [...shell.querySelectorAll('.reveal')];
  const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (entry.isIntersecting) { entry.target.classList.add('show'); io.unobserve(entry.target); }
  }), { threshold: .12 });
  reveals.forEach((el) => io.observe(el));

  const book = $('book3d');
  window.addEventListener('mousemove', (event) => {
    if (!book || innerWidth < 900) return;
    const x = (event.clientX / innerWidth - .5) * 8;
    const y = (event.clientY / innerHeight - .5) * 5;
    book.style.transform = `rotateY(${-24 + x}deg) rotateX(${7 - y}deg) rotateZ(2deg)`;
  });

  const overlay = $('wizardOverlay');
  const form = $('storyForm');
  const steps = [...shell.querySelectorAll('.wstep')];
  const next = $('nextBtn');
  const back = $('backBtn');
  const error = $('error');
  const success = $('success');
  let step = 1;
  let photoFiles = [];
  const photoAnalysis = new WeakMap();
  let project = {};
  let selectedProduct = 'card';
  let projectToken = '';

  const stages = [
    { name:'About you', pct:25, title:'Start with someone special.', body:'The cover changes as you type, so the card starts becoming yours immediately.' },
    { name:'Your story', pct:50, title:'Specific beats impressive.', body:'A tiny detail only you two remember is more valuable than a long polished paragraph.' },
    { name:'Photos & style', pct:75, title:'Give the story a face.', body:'Your photos anchor the real memories; typography, colour and texture shape the finished keepsake.' },
    { name:'Make it theirs', pct:100, title:'Almost there.', body:'Next you will see a product-shaped preview using your own story and photos. Review every designed page before deciding to order.' }
  ];
  const miniLocalPrices = JSON.parse($('miniLocalPrices').textContent);
  const localCurrency = shell.dataset.currency || 'GBP';
  const localSymbol = shell.dataset.currencySymbol || '£';
  function miniDisplayPrice(){ return miniLocalPrices[selectedMiniEdition().variant_id] ?? null; }
  const markets = {
    UK:{name:'United Kingdom',currency:localCurrency,symbol:localSymbol,status:'live',products:{card:{price:16.99,available:true,delivery:'Standard UK delivery included'},mini:{price:miniLocalPrices[String(variants.mini)] ?? 36.99,available:true,delivery:'Delivers to the UK and U.S. · Delivery calculated at checkout'}}},
    US:{name:'United States',currency:localCurrency,symbol:localSymbol,status:'live',products:{card:{price:null,available:false,delivery:'UK delivery only'},mini:{price:miniLocalPrices[String(variants.mini)] ?? null,available:true,delivery:'Delivers to the UK and U.S. · Delivery calculated at checkout'}}}
  };
  const productConfig = {
    card:{label:'Story Card',sku:'story_card',price:16.99,format:'Premium folded card',length:'4 designed sides',visuals:'1 photo required · second optional'},
    mini:{label:'Mini Story',sku:'mini_story_softcover',price:36.99,format:'A5 softcover',length:'24 pages',visuals:'12–20 varied photos recommended · adaptive layouts'}
  };
  const previewPresentation = {
    card:{title:'Your complete Story Card preview',label:'Story Card',samplePages:4,totalPages:4,coverLabel:'FOR YOU',momentLabel:'INSIDE YOUR STORY CARD',status:'This preview shows the front, both inside panels and back of your personalised card.'},
    mini:{title:'Your complete Mini Story preview',label:'Mini Story',samplePages:24,totalPages:24,coverLabel:'YOUR MINI STORY',momentLabel:'INSIDE YOUR MINI STORY',status:'This is your complete 24-page Mini Story. The watermark is for your private preview only; the same clean artwork is frozen for checkout.'}
  };
  let selectedMarket = shell.dataset.country === 'US' ? 'US' : 'UK';
  if (selectedMarket === 'US') selectedProduct = 'mini';
  let samplePdfObjectUrl = '';
  let loadingTimer = 0;
  let previewIsLoading = false;
  let restylePending = false;
  let loadingPhotoUrls = [];
  let loadingPhotoIndex = -1;
  const loadingMessages = [
    'Your preview is free. You decide whether to order once it is ready.',
    'Your photographs and memories are used to create your personal keepsake.',
    'The preview watermark will not appear on your printed keepsake.',
    'Nothing is sent to print while your preview is being prepared.'
  ];
  function clearLoadingPhotos() {
    loadingPhotoUrls.forEach(url => URL.revokeObjectURL(url));
    loadingPhotoUrls = [];
    loadingPhotoIndex = -1;
    $('sampleLoadingStatus')?.querySelector('.loading-photo-stack')?.remove();
    $('sampleLoadingStatus')?.classList.remove('has-loading-photos');
  }
  function prepareLoadingPhotos() {
    clearLoadingPhotos();
    if (!photoFiles.length) return;
    const stack = document.createElement('div');
    stack.className = 'loading-photo-stack';
    const frame = document.createElement('div');
    frame.className = 'loading-photo-frame';
    photoFiles.slice(0, 5).forEach(file => {
      const url = URL.createObjectURL(file);
      loadingPhotoUrls.push(url);
      const img = document.createElement('img');
      img.src = url;
      img.alt = '';
      img.addEventListener('error', () => img.remove(), {once:true});
      frame.append(img);
    });
    const caption = document.createElement('small');
    caption.textContent = 'Your memories · original photos';
    stack.append(frame, caption);
    const box = $('sampleLoadingStatus');
    box.prepend(stack);
    box.classList.add('has-loading-photos');
  }
  const previewUiCopy = JSON.parse($('previewUiCopy')?.textContent || '{}');
  const previewCopy = (key) => previewUiCopy[key] || key;

  function updatePreviewStage(progress = {}) {
    const stage = ['writing','artwork','layout','preview'].includes(progress.stage) ? progress.stage : 'preparing';
    const titleKey = stage === 'preparing' || stage === 'preview' ? selectedProduct+'_preparing' : stage;
    const recipient = (form.querySelector('[name="recipient_label"]')?.value || form.querySelector('[name="partner_name"]')?.value || '').trim();
    $('sampleLoadingTitle').textContent = recipient ? `Bringing your gift for ${recipient} together…` : previewCopy(titleKey);
    $('sampleLoadingDetail').textContent = stage === 'preview' ? 'Preparing your complete preview to open here.' : previewCopy(stage+'_detail');
    $('sampleLoadingStatus').dataset.stage = stage;
    $('sampleLoadingStatus').querySelectorAll('[data-loading-step]').forEach(el => el.classList.toggle('active', el.dataset.loadingStep === stage));
  }

  function setSampleLoading(active) {
    const box=$('sampleLoadingStatus'), reassurance=$('sampleLoadingReassurance'), elapsed=$('sampleLoadingElapsed');
    if(!box)return;
    window.clearInterval(loadingTimer);
    clearLoadingPhotos();
    previewIsLoading=active;
    overlay.classList.toggle('is-preview-generating',active);
    overlay.setAttribute('aria-busy',String(active));
    box.hidden=!active;
    updateSavedMini();
    if(!active){
      const stage=stages[step-1];$('progressText').textContent=stage.name;$('progressPct').textContent=stage.pct+'%';
      return;
    }
    shell.querySelector('.wstep[data-step="4"]')?.prepend(box);
    $('progressText').textContent=previewCopy('preparing');$('progressPct').textContent='';
    updatePreviewStage();
    prepareLoadingPhotos();
    const started=Date.now();
    const updateWait=()=>{
      const seconds=Math.floor((Date.now()-started)/1000);
      if(elapsed)elapsed.textContent=seconds>=90 ? 'Your preview is still being prepared. Please keep this window open.' : '';
      const photos = [...box.querySelectorAll('.loading-photo-frame img')];
      const photoIndex = photos.length ? Math.floor(seconds/6)%photos.length : -1;
      if(photoIndex !== loadingPhotoIndex) {
        photos.forEach((img,index) => img.classList.toggle('active',index===photoIndex));
        loadingPhotoIndex = photoIndex;
      }
      if(box.classList.contains('has-loading-photos') && !photos.length) clearLoadingPhotos();
      // Elapsed time changes reassurance only. Never replace an observed server stage.
      if(reassurance)reassurance.textContent=loadingMessages[Math.floor(seconds/12)%loadingMessages.length];
    };
    updateWait();
    box.scrollIntoView({block:'start',behavior:'smooth'});
    loadingTimer=window.setInterval(updateWait,1000);
  }
  function updateCheckoutAvailability() {
    const button=$('checkoutBtn'), check=$('personalisedPolicyCheck');
    if(!button)return;
    const canCheckout=Boolean(checkoutAvailable[selectedProduct]);
    button.disabled=!canCheckout||!check?.checked||restylePending;
    button.textContent=canCheckout?'Continue to secure checkout':'Checkout available when the store launches';
  }

  function formatMoney(symbol, amount) { return amount == null ? 'Coming soon' : symbol + (Number.isInteger(amount) ? amount : amount.toFixed(2)); }
  function displayName(name) {
    return String(name || '').trim().replace(/(^|[\s'-])(\p{L})/gu,(match,prefix,letter)=>prefix+letter.toLocaleUpperCase());
  }
  function coverNames(first, second) {
    return [displayName(first),displayName(second)].filter(Boolean).sort((a,b)=>a.localeCompare(b,undefined,{sensitivity:'base'})).join(' & ');
  }
  function syncOccasionOther() {
    const field=$('occasionOtherField');
    if(!field)return;
    const isOther=form.querySelector('input[name="occasion_choice"]:checked')?.value==='Other';
    field.hidden=!isOther;
    const input=field.querySelector('input');
    if(input)input.required=isOther;
  }
  function syncArtConsent() {
    const field=$('artConsent');
    if(!field)return;
    const artistic=selectedProduct==='card'&&form.querySelector('input[name="visual_mode"]:checked')?.value!=='Classic Photo Story';
    field.hidden=!artistic;
    const input=field.querySelector('input');
    if(input)input.required=artistic;
  }
  function values() {
    const value = {};
    new FormData(form).forEach((v, k) => value[k] = v);
    const cfg = productConfig[selectedProduct] || productConfig.card;
    const market = markets[selectedMarket] || markets.UK;
    const marketProduct = market.products[selectedProduct] || market.products.card;
    const occasion=value.occasion_choice==='Other'?String(value.occasion_other||'').trim():String(value.occasion_choice||'').trim();
    return { ...value, buyer_name:displayName(value.buyer_name), partner_name:displayName(value.partner_name), occasion, narrative_voice:selectedProduct==='card'?'first_person':(value.narrative_voice||'first_person'), photo_names:photoFiles.length?photoFiles.map((f) => f.name):(selectedProduct==='mini'?savedMini()?.photo_names||[]:[]), product:cfg.sku, product_type:selectedProduct, product_slug:slugFor[selectedProduct], product_version:'ourstory_v12_shopify', market:selectedMarket, market_name:market.name, currency:market.currency, unit_price:selectedProduct==='mini'?miniDisplayPrice():marketProduct.price, delivery_plan:marketProduct.delivery };
  }
  function persist() {
    project = values();
    localStorage.setItem('ourstory_story_project', JSON.stringify(project));
    side(); adaptiveFollowup(); updateSavedMini();
  }
  function savedMini() {
    try {
      const saved=JSON.parse(localStorage.getItem('p1_story_project')||'{}');
      return saved.product_type==='mini'&&saved.project_id&&projectToken?saved:null;
    } catch (_) { return null; }
  }
  function sameMiniDraft(saved,payload) {
    const appearanceKeys=['mini_palette','mini_finish','mini_size','mini_binding','mini_digital','mini_layout','unit_price'];
    return Boolean(saved)&&Object.keys(payload).filter(key=>!appearanceKeys.includes(key)).every(key=>JSON.stringify(saved[key])===JSON.stringify(payload[key]));
  }
  function miniAppearance(payload) {
    return {mini_palette:payload.mini_palette||'auto',mini_finish:payload.mini_finish||'torn_page',mini_layout:payload.mini_layout||'editorial',mini_size:payload.mini_size||'A5',mini_binding:payload.mini_binding||'softcover',mini_digital:payload.mini_digital==='true'||payload.mini_digital===true};
  }
  function syncFinishSwatches() {
    const selected=form.querySelector('[name=mini_palette]:checked')?.value||'auto';
    const relation=String(form.querySelector('[name=recipient_relationship]')?.value||'').toLowerCase();
    const inferred=/partner|wife|husband|girlfriend|boyfriend|fianc|spouse/.test(relation)?'rose':/friend|bestie/.test(relation)?'terracotta':/colleague|coworker|co-worker|mentor|boss|teacher/.test(relation)?'slate':'sage';
    const palette=selected==='auto'?inferred:selected;
    shell.querySelectorAll('.finish-picker').forEach(el=>{
      const choice=el.id==='miniRestylePanel'?$('restylePalette')?.value:selected;
      el.dataset.palette=choice==='auto'?inferred:(choice||palette);
    });
  }
  function syncRestyleControls() {
    const panel=$('miniRestylePanel');
    if(!panel)return;
    panel.hidden=selectedProduct!=='mini';
    $('restylePalette').value=project.mini_palette||'auto';
    panel.querySelectorAll('[name=restyle_finish]').forEach(el=>el.checked=el.value===(project.mini_finish||'torn_page'));
    syncFinishSwatches();
  }
  function updateSavedMini() {
    const button=$('resumeMiniPreview'), saved=savedMini();
    if(!button)return;
    button.hidden=previewIsLoading||selectedProduct!=='mini'||!saved;
    const title=button.querySelector('.saved-preview-title');
    if(title)title.textContent=saved?.partner_name?previewCopy('resume_named').replace('{name}',saved.partner_name):previewCopy('resume');
  }
  function side() {
    const a = $('buyerName').value.trim();
    const b = $('partnerName').value.trim();
    const y = $('startYear').value.trim() || 'OUR STORY';
    $('coverNames').textContent = coverNames(a,b) || 'You & Them'; $('coverYear').textContent = y;
    $('asideTitle').textContent = stages[step-1].title; $('asideBody').textContent = stages[step-1].body;
    const v = values();
    $('memoryCount').textContent = ['how_met','memory_adventure','memory_funny','memory_quiet','memory_milestone'].filter((k) => (v[k] || '').trim().length > 5).length;
    $('photoCount').textContent = photoFiles.length;
  }
  function restore(snapshot) {
    try {
      const saved = snapshot || JSON.parse(localStorage.getItem('ourstory_story_project') || localStorage.getItem('p1_story_project') || '{}');
      if(saved.occasion&&!saved.occasion_choice){
        const known=['Anniversary','Birthday',"Valentine's",'Just because'];
        saved.occasion_choice=known.includes(saved.occasion)?saved.occasion:'Other';
        if(saved.occasion_choice==='Other')saved.occasion_other=saved.occasion;
      }
      Object.entries(saved).forEach(([k,v]) => form.querySelectorAll(`[name="${CSS.escape(k)}"]`).forEach((el) => {
        if (el.type === 'radio') el.checked = el.value === v;
        else if(el.type==='checkbox')el.checked=v==='true'||v===true;
        else if (el.type !== 'file' && typeof v === 'string') el.value = v;
      }));
      selectedProduct = saved.product_type === 'mini' ? 'mini' : 'card';
      projectToken = localStorage.getItem('ourstory_project_token') || sessionStorage.getItem('ourstory_project_token') || '';
    } catch (_) {}
    syncOccasionOther();
    syncArtConsent();
    syncProductUI();
    updateSavedMini();
  }
  function adaptiveFollowup() {
    const v = values(), box = $('inlineFollowup'), q = $('fq1');
    const candidates = [
      ['memory_funny',v.memory_funny,'That sounds like a page people would remember. What tiny detail made it especially funny afterwards?'],
      ['memory_adventure',v.memory_adventure,'What is one small thing from that adventure that instantly takes you both back there?'],
      ['memory_quiet',v.memory_quiet,'Why does that ordinary moment mean more to you than it probably looks from the outside?'],
      ['how_met',v.how_met,'What small detail would make this instantly recognisable to them?']
    ].filter((x) => (x[1] || '').trim().length > 35);
    if (candidates.length) { q.textContent = candidates[0][2]; box.classList.add('show'); } else box.classList.remove('show');
  }
  function syncProductUI() {
    syncFinishSwatches();
    const cfg = productConfig[selectedProduct] || productConfig.card;
    const market = markets[selectedMarket] || markets.UK;
    const mp = market.products[selectedProduct] || market.products.card;
    const radio = form.querySelector(`input[name="product_type"][value="${selectedProduct}"]`); if (radio) radio.checked = true;
    const ids = { finishName:cfg.label, finishFormat:selectedProduct==='mini'?`${form.querySelector('[name=mini_size]:checked')?.value||'A5'} ${form.querySelector('[name=mini_binding]:checked')?.value||'softcover'}`:cfg.format, finishLength:cfg.length, finishVisuals:cfg.visuals, finishPrice:formatMoney(market.symbol,selectedProduct==='mini'?miniDisplayPrice():mp.price), finishDelivery:mp.delivery };
    Object.entries(ids).forEach(([id,val]) => { const el=$(id); if(el) el.textContent=val; });
    const [minPhotos,maxPhotos] = limits[selectedProduct];
    if ($('photoRequirement')) $('photoRequirement').textContent = selectedProduct === 'mini' ? 'Add your photos' : `Choose ${minPhotos === maxPhotos ? minPhotos : `${minPhotos}–${maxPhotos}`} photos`;
    if ($('photoGuidance')) $('photoGuidance').textContent = selectedProduct === 'mini' ? '12–20 varied photos recommended · 5 minimum · the planner selects the strongest images and adapts every layout' : 'One photo is required; a second is optional · tap Remove on any photo you do not want';
    if ($('narrativeVoiceBlock')) $('narrativeVoiceBlock').hidden = selectedProduct === 'card';
    if ($('cardVoiceNote')) $('cardVoiceNote').hidden = selectedProduct !== 'card';
    if ($('miniLayoutChoice')) $('miniLayoutChoice').hidden = selectedProduct !== 'mini';
    if ($('cardThemeChoice')) $('cardThemeChoice').hidden = selectedProduct !== 'card';
    $('miniEditionChoice').hidden=selectedProduct!=='mini';$('miniOriginalNote').hidden=selectedProduct!=='mini';
    $('miniEditionTotal').textContent=formatMoney(localSymbol,miniDisplayPrice());
    shell.querySelectorAll('[data-card-style]').forEach(el=>el.hidden=selectedProduct!=='card');
    if(selectedProduct==='mini'||!form.querySelector('[name=visual_mode]:checked'))form.querySelector('[name=visual_mode][value="Classic Photo Story"]').checked=true;
    syncArtConsent();
    updateSavedMini();
  }
  function invalidateGeneratedProject() {
    if (project.project_id) sessionStorage.removeItem(`ourstory_photos_uploaded_${project.project_id}`);
    projectToken = '';
    project = {};
    localStorage.removeItem('ourstory_project_token');
    sessionStorage.removeItem('ourstory_project_token');
    localStorage.removeItem('p1_story_project');
  }
  function renderPhotoGrid() {
    const grid = $('photoGrid');
    grid.innerHTML = '';
    photoFiles.forEach((file, index) => {
      const item = document.createElement('div');
      item.className = 'photo-item';
      const img = document.createElement('img');
      img.alt = `Selected photo: ${file.name}`;
      const url = URL.createObjectURL(file);
      img.onload = () => URL.revokeObjectURL(url);
      img.onerror = () => URL.revokeObjectURL(url);
      img.src = url;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'photo-remove';
      remove.setAttribute('aria-label', `Remove ${file.name}`);
      remove.innerHTML = '<span aria-hidden="true">×</span><b>Remove</b>';
      remove.addEventListener('click', () => {
        photoFiles.splice(index, 1);
        invalidateGeneratedProject();
        renderPhotoGrid();
        error.textContent = '';
        persist();
      });
      item.append(img, remove);
      grid.appendChild(item);
    });
    side();
  }
  function syncMarketUI() {
    const market = markets[selectedMarket] || markets.UK;
    localStorage.setItem('ourstory_market', selectedMarket);
    if ($('marketSelect')) $('marketSelect').value = selectedMarket;
    if ($('wizardMarketName')) $('wizardMarketName').textContent = market.name + (market.status === 'live' ? '' : ' · preview market');
    ['card','mini'].forEach((type) => {
      const cfg = market.products[type];
      shell.querySelectorAll(`[data-price="${type}"]`).forEach((el) => el.textContent = cfg.available ? formatMoney(market.symbol,cfg.price) : 'UK only');
      shell.querySelectorAll(`[data-delivery="${type}"]`).forEach((el) => el.textContent = cfg.delivery);
      shell.querySelectorAll(`.product-btn[data-product="${type}"]`).forEach((btn) => {
        const card = btn.closest('.product-card');
        if (!cfg.available) { card?.classList.add('unavailable'); btn.textContent='UK delivery only'; btn.disabled=true; }
        else { card?.classList.remove('unavailable'); btn.disabled=false; btn.textContent=type==='card'?'Preview my card →':'Preview a mini story →'; }
      });
    });
    shell.querySelectorAll('[data-open-wizard][data-product="card"]').forEach(btn => { btn.disabled = selectedMarket === 'US'; });
    const cardChoice = form.querySelector('input[name="product_type"][value="card"]');
    if (cardChoice) cardChoice.disabled = selectedMarket === 'US';
    syncProductUI();
  }
  function validate() {
    const current = steps[step-1];
    if (step===1) {
      if (!current.querySelector('input[name="product_type"]:checked')) return 'Choose what you want to create.';
      if (!$('buyerName').value.trim() || !$('partnerName').value.trim()) return 'Add both names to continue.';
      if (!current.querySelector('input[name="occasion_choice"]:checked')) return 'Choose an occasion to continue.';
      if (current.querySelector('input[name="occasion_choice"]:checked')?.value==='Other' && !current.querySelector('[name="occasion_other"]')?.value.trim()) return 'Tell us the occasion in your own words.';
    }
    if (step===2) {
      const howMetLength=current.querySelector('[name="how_met"]').value.trim().length;
      const memoryCount=[...current.querySelectorAll('.memory-card textarea')].filter((x) => x.value.trim().length >= 12).length;
      if (selectedProduct==='card' && howMetLength < 12) return 'Tell us a little about the person receiving your card.';
      if (selectedProduct==='card' && memoryCount < 1) return 'Add one more memory for the message. A short answer is fine.';
      if (selectedProduct!=='card' && howMetLength < 20) return 'Give us at least a couple of sentences about how you met.';
      if (selectedProduct!=='card' && memoryCount < 3) return 'Add at least three memories. Short answers are fine.';
    }
    if (step===3) {
      if (!current.querySelector('input[name="tone"]:checked') || !current.querySelector('input[name="visual_mode"]:checked') || !form.querySelector('[name="art_style"]')?.value) return 'Choose a writing tone, visual treatment and design style.';
      if (current.querySelector('input[name="visual_mode"]:checked')?.value!=='Classic Photo Story' && !current.querySelector('[name="ai_image_consent"]')?.checked) return 'Please confirm the photo-processing permission for the artistic portrait.';
      const [min,max] = limits[selectedProduct];
      const saved=selectedProduct==='mini'?savedMini():null;
      const photoCount=photoFiles.length||(sameMiniDraft(saved,values())?(saved.photo_names||[]).length:0);
      if (photoCount < min || photoCount > max) return `Add ${min === max ? min : `${min}–${max}`} photos for this format.`;
    }
    return '';
  }
  function go(n) {
    step=Math.max(1,Math.min(4,n)); steps.forEach((x,i)=>x.classList.toggle('active',i===step-1));
    const stage=stages[step-1]; $('progressBar').style.width=stage.pct+'%'; $('progressText').textContent=stage.name; $('progressPct').textContent=stage.pct+'%';
    back.style.visibility=step===1?'hidden':'visible'; next.textContent=step===4?'Generate my free sample →':'Continue →'; side(); adaptiveFollowup();
    if($('saveMiniDraft'))$('saveMiniDraft').hidden=step!==4||selectedProduct!=='mini';
    shell.querySelector('.wizard-main').scrollTo({top:0,behavior:'smooth'});
  }
  async function callApi(action, payload={}) {
    const response = await fetch(apiBase, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({action,...payload}) });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      const apiError = new Error(data.error || `request_failed_${response.status}`);
      if (action === 'generate_mini_full_preview' && typeof data.message === 'string') apiError.customerMessage = data.message;
      throw apiError;
    }
    return data;
  }
  async function uploadPhotos(projectId, token) {
    const checkpointKey='ourstory_photo_checkpoint_'+projectId;
    let uploaded=[];
    if(selectedProduct==='mini'){try{uploaded=JSON.parse(sessionStorage.getItem(checkpointKey)||'[]');}catch(_){}}
    for (const originalFile of photoFiles) {
      const fileKey=JSON.stringify([originalFile.name,originalFile.size,originalFile.lastModified]);
      if(selectedProduct==='mini'&&uploaded.includes(fileKey))continue;
      const file = await normaliseImage(originalFile);
      const prep = await callApi('prepare_upload',{project_id:projectId,project_token:token,file_name:file.name,content_type:file.type,size:file.size});
      const upload = await fetch(prep.signed_url,{method:'PUT',headers:{'Content-Type':file.type,'x-upsert':'false'},body:file});
      if (!upload.ok) throw new Error('photo_upload_failed');
      await callApi('register_photo',{project_id:projectId,project_token:token,storage_key:prep.storage_key,original_filename:file.name,content_type:file.type,size:file.size,photo_analysis:photoAnalysis.get(file)});
      if(selectedProduct==='mini'){uploaded.push(fileKey);sessionStorage.setItem(checkpointKey,JSON.stringify(uploaded));}
    }
  }
  async function decodeImage(file) {
    if (typeof createImageBitmap === 'function') {
      try { return await createImageBitmap(file, { imageOrientation:'from-image' }); } catch (_) {}
    }
    const url = URL.createObjectURL(file);
    const img = new Image();
    try {
      await new Promise((resolve, reject) => { img.onload = resolve; img.onerror = reject; img.src = url; });
      return img;
    } finally { URL.revokeObjectURL(url); }
  }
  async function normaliseImage(file) {
    const type = String(file.type || '').toLowerCase();
    const isHeicName = /\.hei[cf]$/i.test(file.name);
    if (!['image/jpeg','image/png','image/webp','image/heic','image/heif'].includes(type) && !isHeicName) throw new Error('unsupported_photo_format');
    const bitmap = await decodeImage(file);
    const max = selectedProduct==='mini'?6000:4000, scale = Math.min(1, max / Math.max(bitmap.width, bitmap.height),Math.sqrt(16000000/(bitmap.width*bitmap.height)));
    const canvas = document.createElement('canvas'); canvas.width = Math.round(bitmap.width * scale); canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext('2d', { alpha:false }).drawImage(bitmap, 0, 0, canvas.width, canvas.height); if (bitmap.close) bitmap.close();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', .94));
    if (!blob) throw new Error('photo_conversion_failed');
    const prepared=new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type:'image/jpeg', lastModified:file.lastModified });
    if(selectedProduct==='mini'&&window.OurStoryPhotoAnalysis)photoAnalysis.set(prepared,await window.OurStoryPhotoAnalysis.analyse(canvas,shell.dataset));
    return prepared;
  }
  async function generateSample(saveOnly=false) {
    const payload = values();
    const saved=selectedProduct==='mini'?savedMini():null;
    let created = project.project_id && projectToken ? { project_id:project.project_id, project_token:projectToken } : null;
    if(selectedProduct==='mini'){
      created=sameMiniDraft(saved,payload)?{project_id:saved.project_id,project_token:projectToken}:null;
    }
    const reused=Boolean(created&&selectedProduct==='mini');
    const reuseOnly=reused&&['preview_ready','appearance_pending'].includes(saved.status);
    if(reused&&JSON.stringify(miniAppearance(saved))!==JSON.stringify(miniAppearance(payload))) {
      await callApi('update_mini_appearance',{project_id:created.project_id,project_token:projectToken,appearance:miniAppearance(payload)});
    }
    if (!created) created = await callApi('create_project',{payload:{
      product_slug:payload.product_slug, purchaser_email:payload.email || payload.purchaser_email,
      customer_first_name:payload.buyer_name || payload.customer_first_name || $('buyerName').value,
      partner_first_name:payload.partner_name || payload.partner_first_name || $('partnerName').value,
      occasion:payload.occasion, recipient_relationship:payload.recipient_relationship, recipient_label:payload.recipient_label, relationship_start_year:payload.start_year || payload.relationship_start_year,
      tone:payload.tone, narrative_voice:payload.narrative_voice, illustration_style:payload.art_style, visual_mode:payload.visual_mode, ai_image_consent:payload.ai_image_consent, dedication:payload.dedication, mini_layout:payload.mini_layout, mini_size:payload.mini_size,mini_binding:payload.mini_binding,mini_digital:payload.mini_digital==='true',mini_palette:payload.mini_palette,mini_finish:payload.mini_finish,card_palette:payload.card_palette,
      how_met:payload.how_met, memory_adventure:payload.memory_adventure, memory_funny:payload.memory_funny,
      memory_quiet:payload.memory_quiet, memory_milestone:payload.memory_milestone, followup_1:payload.followup_1
    }});
    projectToken=created.project_token; sessionStorage.setItem('ourstory_project_token',projectToken); localStorage.setItem('ourstory_project_token',projectToken);
    project={...payload,project_id:created.project_id,status:'generating_preview',created_at:new Date().toISOString()};
    localStorage.setItem('p1_story_project',JSON.stringify(project));
    updateSavedMini();
    const uploadFlag='ourstory_photos_uploaded_'+created.project_id;
    if (sessionStorage.getItem(uploadFlag) !== 'true'&&(!reused||photoFiles.length)) {
      await uploadPhotos(created.project_id,projectToken);
      sessionStorage.setItem(uploadFlag,'true');
    }
    if(saveOnly){
      project={...project,status:'draft_saved'};
      localStorage.setItem('p1_story_project',JSON.stringify(project));
      return {status:'draft_saved'};
    }
    const action=selectedProduct==='mini'?'generate_mini_full_preview':'generate_preview';
    const generated=await requestPreview(action,created.project_id,projectToken,reuseOnly);
    project={...payload,project_id:created.project_id,status:generated.status,created_at:project.created_at};
    localStorage.setItem('p1_story_project',JSON.stringify(project));
    return generated;
  }
  async function requestPreview(action,projectId,token,reuseOnly=false) {
    const request={project_id:projectId,project_token:token,...(reuseOnly?{reuse_existing_only:true}:{})};
    let generated=await callApi(action,request);
    let polls=0;
    while (generated?.preview_pending) {
      polls+=1;
      const progress=generated.preview_progress||{};
      updatePreviewStage(progress);
      if (polls>180) throw new Error('preview_still_processing');
      const pollDelay=progress.stage==='writing'?1800:1100;
      await new Promise((resolve)=>window.setTimeout(resolve,pollDelay));
      generated=await callApi(action,request);
    }
    return generated;
  }
    async function loadSamplePdf(result, presentation) {
    if (previewIsLoading) updatePreviewStage({stage:'preview'});
    const pdfButton=$('samplePdfBtn'), openButton=$('samplePdfOpenBtn'), pdfViewer=$('samplePdfViewer'), pdfFrame=$('samplePdfFrame'), loading=$('samplePdfLoading'), mobileCard=$('samplePdfMobile');
    if (!pdfButton || !openButton || !pdfViewer || !pdfFrame || !loading || !mobileCard) return;
    const sample=$('samplePreview');
    sample?.before(pdfViewer);
    const checkoutPanel=shell.querySelector('.preview-checkout-panel');
    if(checkoutPanel)pdfViewer.after(checkoutPanel);
    const pdfActions=shell.querySelector('.sample-pdf-actions');
    if(checkoutPanel&&pdfActions)checkoutPanel.after(pdfActions);
    if (samplePdfObjectUrl) URL.revokeObjectURL(samplePdfObjectUrl);
    samplePdfObjectUrl='';
    pdfButton.hidden=true; openButton.hidden=true;
    pdfFrame.src='about:blank';
    pdfFrame.hidden=true; mobileCard.hidden=true; loading.hidden=false;
    // Never flash the previous project's cover while a new PDF loads or fails.
    const previousCover=$('sampleMobileCover');
    if(previousCover){previousCover.hidden=true;previousCover.querySelector('canvas')?.remove();}
    pdfViewer.hidden=!result.sample_pdf_url;
    if (!result.sample_pdf_url) { $('samplePreview').hidden=false; return; }
    $('samplePreview').hidden=true;
    const samplePages=Number(result.sample_page_count || presentation.samplePages);
    const totalPages=Number(result.complete_page_count || presentation.totalPages);
    $('samplePdfLabel').textContent='Your '+samplePages+'-page '+presentation.label+' preview';
    $('samplePdfHint').textContent=samplePages===totalPages?'Review all '+totalPages+' designed pages below.':'This shows '+samplePages+' representative pages from the '+totalPages+'-page product.';
    try {
      const response=await fetch(result.sample_pdf_url,{cache:'no-store'});
      if(!response.ok)throw new Error('preview_download_failed');
      const blob=await response.blob();
      samplePdfObjectUrl=URL.createObjectURL(blob);
      const mobilePdf=/iPad|iPhone|iPod/i.test(navigator.userAgent) || (navigator.platform==='MacIntel' && navigator.maxTouchPoints>1) || matchMedia('(max-width: 720px)').matches;
      loading.hidden=true;
      if (mobilePdf) {
        mobileCard.hidden=false;
        const cover=mobileCard.querySelector('.sample-mobile-cover');
        if(cover){
          try {
            const pdfjs=await import(shell.dataset.pdfLibUrl);
            pdfjs.GlobalWorkerOptions.workerSrc=shell.dataset.pdfWorkerUrl;
            const document=await pdfjs.getDocument({data:new Uint8Array(await blob.arrayBuffer()),isEvalSupported:false}).promise;
            const first=await document.getPage(1),viewport=first.getViewport({scale:Math.min(2,700/first.getViewport({scale:1}).width)});
            const canvas=window.document.createElement('canvas');canvas.width=Math.ceil(viewport.width);canvas.height=Math.ceil(viewport.height);canvas.className='pdf-cover-canvas';canvas.setAttribute('role','img');canvas.setAttribute('aria-label','First page of your actual watermarked preview');
            await first.render({canvasContext:canvas.getContext('2d'),viewport}).promise;
            cover.replaceChildren(canvas);cover.hidden=false;cover.classList.remove('protected-fallback');await document.destroy();
          }catch(_){cover.hidden=true;}
        }
      } else {
        pdfFrame.hidden=false;
        pdfFrame.src=samplePdfObjectUrl+'#view=FitH&toolbar=0&navpanes=0';
      }
      pdfButton.hidden=false; openButton.hidden=false;
      openButton.innerHTML='<span aria-hidden="true">↗</span> Open my full '+presentation.label+' preview';
      openButton.onclick=()=>window.open(samplePdfObjectUrl || result.sample_pdf_url,'_blank','noopener');
      pdfButton.replaceChildren(Object.assign(document.createElement('span'),{textContent:'↓'}),document.createTextNode(' '+previewCopy('download')));
      pdfButton.firstElementChild.setAttribute('aria-hidden','true');
      pdfButton.onclick=()=>{
        const download=document.createElement('a');
        download.href=samplePdfObjectUrl;
        download.download=result.sample_pdf_filename || 'OurStory-'+presentation.label.replace(/\s+/g,'-')+'-preview.pdf';
        document.body.appendChild(download); download.click(); download.remove();
      };
    } catch (_) {
      loading.hidden=true; mobileCard.hidden=false; openButton.hidden=false;
      openButton.onclick=()=>window.open(result.sample_pdf_url,'_blank','noopener');
      $('samplePdfHint').textContent='Your preview is ready to open securely.';
    }
  }
    async function showSample(result) {
    const preview=result.preview;
    if (preview) {
      $('samplePhoto').hidden=true;$('samplePhotoImage').removeAttribute('src');
      const presentation=previewPresentation[selectedProduct] || previewPresentation.card;
      $('sampleFormatEyebrow').textContent='Your private '+presentation.label+' preview';
      $('sampleTitle').textContent=presentation.title;
      $('sampleCoverTitle').textContent=preview.cover_title || (project.buyer_name+' & '+project.partner_name);
      $('sampleKicker').textContent=preview.cover_subtitle || 'A first look'; $('sampleHeading').textContent=preview.sample_spread_heading || preview.cover_title;
      $('sampleText').textContent=preview.sample_spread_text || ''; $('sampleQuote').textContent=preview.pull_quote || '';
      $('sampleCoverLabel').textContent=presentation.coverLabel; $('sampleMomentLabel').textContent=presentation.momentLabel;
      if($('sampleMobileCoverLabel'))$('sampleMobileCoverLabel').textContent=presentation.coverLabel;
      if($('sampleMobileCoverTitle'))$('sampleMobileCoverTitle').textContent=preview.cover_title || (project.buyer_name+' & '+project.partner_name);
      if($('sampleMobileCoverSubtitle'))$('sampleMobileCoverSubtitle').textContent=preview.cover_subtitle || 'A first look';
      const mobileHint=$('samplePdfMobile')?.querySelector(':scope > small');
      if(mobileHint)mobileHint.textContent='Your actual cover, from your private preview. Open the PDF to review all '+Number(result.sample_page_count||presentation.samplePages)+' designed pages.';
      if($('sampleMobileCoverImage'))$('sampleMobileCoverImage').alt='Your uploaded photo — open the PDF for the designed '+presentation.label+' cover';
      const mobileCover=$('sampleMobileCover'); if(mobileCover) mobileCover.dataset.relationship=project.recipient_relationship || '';
      $('samplePreview').dataset.product=selectedProduct; $('samplePreview').hidden=Boolean(result.sample_pdf_url);
      await loadSamplePdf(result,presentation);
      if (photoFiles[0]) {
        const reader=new FileReader(); reader.onload=(event)=>{ $('samplePhotoImage').src=event.target.result; $('samplePhoto').hidden=false; const mobileImage=$('sampleMobileCoverImage'); if(mobileImage){mobileImage.src=event.target.result;mobileImage.hidden=false;$('sampleMobileCover')?.classList.add('has-image');} }; reader.readAsDataURL(photoFiles[0]);
      }
      const canCheckout=Boolean(checkoutAvailable[selectedProduct]);
      if($('personalisedPolicyCheck'))$('personalisedPolicyCheck').checked=false;
      updateCheckoutAvailability();
      $('sampleStatus').textContent=canCheckout?presentation.status+' Continue when you are happy with the design and the words.':presentation.status+' Checkout will open when this product is released.';
      $('samplePrivacy').textContent=previewCopy('protected_body');
    } else {
      $('sampleTitle').textContent='Your private project is saved.'; $('sampleStatus').textContent='AI generation is waiting for the private OpenAI key to be enabled.'; $('sampleStatus').classList.add('integration-error');
    }
    restylePending=false;syncRestyleControls();updateCheckoutAvailability();
    success.classList.add('open'); success.setAttribute('aria-hidden','false');
  }

  shell.querySelectorAll('[data-open-wizard]').forEach((button)=>button.addEventListener('click',()=>{
    if(button.disabled)return; selectedProduct=button.dataset.product||selectedProduct||'card'; const mp=(markets[selectedMarket]||markets.UK).products[selectedProduct]; if(mp&&!mp.available)return;
    syncProductUI(); overlay.classList.add('open'); overlay.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; go(1);
  }));
  form.querySelectorAll('input[name="product_type"]').forEach((radio)=>radio.addEventListener('change',()=>{ const mp=(markets[selectedMarket]||markets.UK).products[radio.value]; if(mp&&!mp.available){radio.checked=false;error.textContent='That physical product is not enabled in this market yet.';return;} selectedProduct=radio.value;syncProductUI();persist(); }));
  form.querySelectorAll('input[name="occasion_choice"]').forEach((radio)=>radio.addEventListener('change',()=>{syncOccasionOther();persist();}));
  form.querySelectorAll('input[name="visual_mode"]').forEach((radio)=>radio.addEventListener('change',()=>{syncArtConsent();persist();}));
  form.querySelectorAll('[name=mini_size],[name=mini_binding],[name=mini_digital],[name=mini_palette],[name=mini_finish],[name=mini_layout]').forEach(el=>el.addEventListener('change',()=>{syncProductUI();persist();}));
  form.querySelectorAll('[name=card_palette]').forEach(el=>el.addEventListener('change',()=>{invalidateGeneratedProject();syncProductUI();persist();}));
  shell.querySelectorAll('[data-open-wizard][data-palette]').forEach(el=>el.addEventListener('click',()=>{const choice=form.querySelector('[name="mini_palette"][value="'+CSS.escape(el.dataset.palette)+'"]');if(choice)choice.checked=true;form.querySelector('[name=recipient_relationship]').value=({sage:'Family member',terracotta:'Friend',rose:'Partner',slate:'Colleague'})[el.dataset.palette]||'Other';invalidateGeneratedProject();syncFinishSwatches();persist();}));
  [$('buyerName'),$('partnerName')].forEach((input)=>input?.addEventListener('blur',()=>{input.value=displayName(input.value);persist();}));
  $('closeWizard').addEventListener('click',()=>{overlay.classList.remove('open');overlay.setAttribute('aria-hidden','true');document.body.style.overflow='';});
  back.addEventListener('click',()=>go(step-1)); form.addEventListener('input',()=>{persist();error.textContent='';});
  next.addEventListener('click',async()=>{
    persist(); const message=validate(); if(message){error.textContent=message;return;} if(step<4){go(step+1);return;}
    next.disabled=true; next.textContent=selectedProduct==='mini'?'Creating your complete Mini preview…':'Creating your private sample…'; error.textContent=''; error.classList.remove('integration-error'); setSampleLoading(true);
    try { await showSample(await generateSample()); } catch(err) { const message=String(err); error.textContent=selectedProduct==='mini'&&err.customerMessage?err.customerMessage:message.includes('artistic_preview_unavailable')?'We couldn\'t create your selected artistic portrait yet. Your photos and answers are safely saved. Please try again shortly, or go back and choose Classic Photo.':message.includes('unsupported_photo')?'Choose a JPG, PNG, WebP or iPhone HEIC photo.':message.includes('photo_')?'One photo could not be prepared. Remove it and choose the original image again.':'Your answers are saved. Please tap “Try creating my sample again”.'; next.textContent='Try creating my sample again →'; error.classList.add('integration-error'); console.error(err); }
    finally { setSampleLoading(false); next.disabled=false; if(next.textContent==='Creating your private sample…'||next.textContent==='Creating your complete Mini preview…') next.textContent='Generate my free sample →'; }
  });
  $('photoInput').addEventListener('change',()=>{
    const [,max]=limits[selectedProduct];
    const incoming=[...$('photoInput').files];
    const unique=[...photoFiles,...incoming].filter((file,index,all)=>all.findIndex((candidate)=>candidate.name===file.name&&candidate.size===file.size&&candidate.lastModified===file.lastModified)===index);
    photoFiles=unique.slice(0,max);
    $('photoInput').value='';
    invalidateGeneratedProject();
    renderPhotoGrid();
    error.textContent=unique.length>max?`This format accepts up to ${max} photos. Remove one to choose a different photo.`:'';
    persist();
  });
  $('checkoutBtn').addEventListener('click',async()=>{
    if(!project.project_id||!projectToken||restylePending||!checkoutAvailable[selectedProduct]||!$('personalisedPolicyCheck')?.checked)return;
    const button=$('checkoutBtn'); button.disabled=true; button.textContent='Opening checkout…';
    try {
      if(selectedProduct==='mini') {
        const currentResponse=await fetch('/cart.js');if(!currentResponse.ok)throw new Error('cart_read_failed');
        const current=await currentResponse.json(),edition=selectedMiniEdition();
        if(current.items.some(item=>item.properties?._ourstory_project_id&&item.properties._ourstory_project_id!==project.project_id))throw new Error('another_personalised_gift_in_cart');
        await callApi('attach_cart',{project_id:project.project_id,project_token:projectToken,cart_token:current.token,variant_id:edition.variant_id});
        const existing=current.items.find(item=>item.properties?._ourstory_project_id===project.project_id);
        if(existing&&String(existing.variant_id)!==edition.variant_id)throw new Error('cart_edition_mismatch');
        const response=await fetch(existing?'/cart/change.js':'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(existing?{id:existing.key,quantity:1}:{items:[{id:Number(edition.variant_id),quantity:1,properties:{'_ourstory_project_id':project.project_id,'Preview':'Complete 24-page design reviewed before checkout','Digital PDF':edition.digital_download?'Included':'Not selected','Personalised terms':'Accepted before checkout'}}]})});
        if(!response.ok)throw new Error('cart_add_failed');
        window.location.assign('/checkout');return;
      }
      const cartResponse=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:selectedProduct==='mini'?Number(selectedMiniEdition().variant_id):variants[selectedProduct],quantity:1,properties:{'_ourstory_project_id':project.project_id,'Proof process':'Every page is reviewed before printing.','Personalised terms':'Accepted before checkout'}}]})});
      if(!cartResponse.ok)throw new Error('cart_add_failed'); const cart=await fetch('/cart.js').then((r)=>r.json());
      await callApi('attach_cart',{project_id:project.project_id,project_token:projectToken,cart_token:cart.token,variant_id:selectedProduct==='mini'?selectedMiniEdition().variant_id:String(variants[selectedProduct])}); window.location.assign('/checkout');
    } catch(err) { updateCheckoutAvailability();button.textContent='Try secure checkout again';$('sampleStatus').textContent=String(err).includes('another_personalised_gift_in_cart')?'There is another personalised gift in your cart. Complete that order or remove it from your cart, then continue with this book.':'We could not open checkout. Your preview is safely saved; please try again.';$('sampleStatus').classList.add('integration-error');console.error(err); }
  });
  if($('personalisedPolicyCheck'))$('personalisedPolicyCheck').addEventListener('change',updateCheckoutAvailability);
  $('restyleApply')?.addEventListener('click',async()=>{
    const saved=savedMini(),button=$('restyleApply'),panel=$('miniRestylePanel'),status=$('restyleStatus');
    if(!saved||button.disabled||previewIsLoading)return;
    const appearance={mini_palette:$('restylePalette').value,mini_finish:panel.querySelector('[name=restyle_finish]:checked')?.value||'torn_page'};
    const controls=[...panel.querySelectorAll('input,select,button')];
    controls.forEach(el=>el.disabled=true);restylePending=true;updateCheckoutAvailability();
    status.textContent=previewCopy('restyle_working');
    try {
      await callApi('update_mini_appearance',{project_id:saved.project_id,project_token:projectToken,appearance});
      for(const [key,value] of Object.entries(appearance))form.querySelectorAll('[name="'+key+'"]').forEach(el=>el.checked=el.value===value);
      project={...saved,...appearance,status:'appearance_pending'};
      localStorage.setItem('p1_story_project',JSON.stringify(project));
      localStorage.setItem('ourstory_story_project',JSON.stringify(project));
      const result=await requestPreview('generate_mini_full_preview',saved.project_id,projectToken,true);
      project={...project,status:result.status};localStorage.setItem('p1_story_project',JSON.stringify(project));
      await showSample(result);status.textContent=previewCopy('restyle_saved');
    } catch(err) {
      status.textContent=previewCopy('restyle_error');
    } finally {
      controls.forEach(el=>el.disabled=false);syncFinishSwatches();updateCheckoutAvailability();
    }
  });
  $('miniRestylePanel')?.addEventListener('change',()=>{
    const saved=savedMini(),panel=$('miniRestylePanel');
    restylePending=!saved||saved.status==='appearance_pending'||$('restylePalette').value!==(saved.mini_palette||'auto')||(panel.querySelector('[name=restyle_finish]:checked')?.value||'torn_page')!==(saved.mini_finish||'torn_page');
    syncFinishSwatches();updateCheckoutAvailability();
  });
  const closeSample=()=>{success.classList.remove('open');success.setAttribute('aria-hidden','true');overlay.classList.remove('open');overlay.setAttribute('aria-hidden','true');document.body.style.overflow='';};
  $('closeSuccess').addEventListener('click',closeSample); $('closeSample').addEventListener('click',closeSample);
  if ($('marketSelect')) $('marketSelect').addEventListener('change',()=>{selectedMarket=$('marketSelect').value;syncMarketUI();if(selectedProduct==='card'&&!markets[selectedMarket].products.card.available){selectedProduct='mini';syncProductUI();}});
  if($('wizardMarketCycle')) $('wizardMarketCycle').remove();
  const sticky=shell.querySelector('.mobile-sticky-cta'); if(sticky){const update=()=>{if(innerWidth>760){sticky.classList.remove('sticky-visible');return;}const y=scrollY||document.documentElement.scrollTop;sticky.classList.toggle('sticky-visible',y>560&&(innerHeight+y)<document.documentElement.scrollHeight-520);};addEventListener('scroll',update,{passive:true});addEventListener('resize',update);update();}
  const resumeMini=document.createElement('button');
  resumeMini.id='resumeMiniPreview';resumeMini.type='button';resumeMini.className='saved-preview-control';resumeMini.hidden=true;
  resumeMini.innerHTML='<span class="saved-preview-icon" aria-hidden="true">↗</span><span class="saved-preview-copy"><strong class="saved-preview-title"></strong><small></small></span><span aria-hidden="true">→</span>';
  resumeMini.querySelector('small').textContent=previewCopy('resume_detail');
  resumeMini.setAttribute('aria-description','Continue the last saved Mini using its existing story and uploaded photos.');
  form.before(resumeMini);
  const saveMini=document.createElement('button');
  saveMini.id='saveMiniDraft';saveMini.type='button';saveMini.className='save-draft-control';saveMini.hidden=true;
  const saveLabel=document.createElement('strong'),saveDetail=document.createElement('small');
  saveLabel.textContent=previewCopy('save');saveDetail.textContent=previewCopy('save_detail');saveMini.append(saveLabel,saveDetail);
  next.after(saveMini);
  saveMini.addEventListener('click',async()=>{
    if(saveMini.disabled||previewIsLoading)return;
    const message=validate();if(message){error.textContent=message;return;}
    const controls=[...form.querySelectorAll('input,select,textarea,button'),next,back,resumeMini];
    const disabled=controls.map(el=>el.disabled);
    // Collect values before disabling form inputs: disabled controls are excluded from FormData.
    const task=generateSample(true);
    controls.forEach(el=>el.disabled=true);saveMini.disabled=true;saveLabel.textContent=previewCopy('saving');
    try{await task;error.textContent=previewCopy('saved');error.setAttribute('aria-live','polite');}
    catch(err){error.textContent=err.customerMessage||'We could not finish saving your uploads. Keep this window open and try again; completed photos will be reused.';}
    finally{controls.forEach((el,i)=>el.disabled=disabled[i]);saveMini.disabled=false;saveLabel.textContent=previewCopy('save');updateSavedMini();}
  });
  resumeMini.addEventListener('click',async()=>{
    const saved=savedMini();if(!saved||resumeMini.disabled)return;
    restore(saved);project={...saved};go(4);
    const controls=[...form.querySelectorAll('input,select,textarea,button'),next,back];
    const disabled=controls.map(el=>el.disabled);
    controls.forEach(el=>el.disabled=true);resumeMini.disabled=true;
    error.textContent='';error.setAttribute('aria-live','polite');setSampleLoading(true);
    try {
      const result=await requestPreview('generate_mini_full_preview',saved.project_id,projectToken,saved.status!=='draft_saved');
      project={...saved,status:result.status};localStorage.setItem('p1_story_project',JSON.stringify(project));
      await showSample(result);
    } catch(err) {
      error.textContent=err.customerMessage||(String(err).includes('saved_story_required')?'Your saved project has not finished its first story yet. Complete the form and choose Generate my free sample.':'We could not reconnect to your saved preview. Please try again. Your saved story has not been regenerated.');
      error.classList.add('integration-error');
    } finally {
      setSampleLoading(false);controls.forEach((el,i)=>el.disabled=disabled[i]);resumeMini.disabled=false;
    }
  });
  restore();
  if (selectedMarket === 'US') selectedProduct = 'mini';
  $('deliveryCountrySelect')?.addEventListener('change', () => { persist(); $('ourstoryCountryForm').requestSubmit(); });
  syncMarketUI();syncProductUI();go(1);
  if(new URLSearchParams(location.search).get('create')==='mini') {
    selectedProduct='mini';syncProductUI();overlay.classList.add('open');overlay.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';go(1);
  }
})();
